"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayBufferToHex = exports.makeRange = exports.setRangeBound = exports.makeRandomBytes = exports.throwOnErrorResponse = exports.applyMixins = void 0;
const error_1 = require("../message/error");
const network_1 = require("../network");
const events_1 = require("../network/modules/events/events");
__exportStar(require("./transactions"), exports);
function applyMixins(network, modules) {
    modules.forEach(module => {
        const namespace = module._namespace_;
        // @ts-ignore
        network[namespace] = {};
        const props = Object.getOwnPropertyNames(module);
        props.forEach(prop => {
            const val = module[prop];
            if (typeof val === "function") {
                network[namespace][prop] = val.bind(network);
            }
            else {
                network[namespace][prop] = val;
            }
        });
    });
}
exports.applyMixins = applyMixins;
function throwOnErrorResponse(msg) {
    var _a;
    const content = (_a = msg.getContent()) === null || _a === void 0 ? void 0 : _a.get(4);
    if (content instanceof Map &&
        typeof content.get(0) === "number" &&
        Math.sign(content.get(0)) === -1) {
        throw new error_1.ManyError(Object.fromEntries(content));
    }
    return msg;
}
exports.throwOnErrorResponse = throwOnErrorResponse;
function makeRandomBytes(size = 32) {
    return crypto.getRandomValues(new Uint8Array(size));
}
exports.makeRandomBytes = makeRandomBytes;
function setRangeBound({ rangeMap, rangeType, boundType, value, }) {
    const rangeVal = rangeType === events_1.RangeType.lower ? 0 : 1;
    const boundVal = (boundType !== network_1.BoundType.unbounded
        ? [boundType === network_1.BoundType.inclusive ? 0 : 1, value]
        : []);
    rangeMap.set(rangeVal, boundVal);
}
exports.setRangeBound = setRangeBound;
function makeRange(range) {
    const rangeMap = new Map();
    if (range && range.length) {
        const [lower, upper] = range;
        if (lower) {
            setRangeBound(Object.assign({ rangeMap, rangeType: events_1.RangeType.lower }, lower));
        }
        if (upper) {
            setRangeBound(Object.assign({ rangeMap, rangeType: events_1.RangeType.upper }, upper));
        }
    }
    return rangeMap;
}
exports.makeRange = makeRange;
function arrayBufferToHex(b) {
    return Buffer.from(b).toString("hex");
}
exports.arrayBufferToHex = arrayBufferToHex;
